import { useCreateProposal } from './CreateProposalManager';

export const useCreateProposalState = () => {
    const state = useCreateProposal();

    return state;
};
